import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/store/modules/config'
import user from '@/store/modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    config,
    user,
  }
})
